// extracted by mini-css-extract-plugin
module.exports = {"scrollDownButton":"ScrollDownButton_scrollDownButton__3g6wE","sdb04":"ScrollDownButton_sdb04__s-x0x"};